import { render } from "./addNotePanel.vue?vue&type=template&id=3577dfa1"
import script from "./addNotePanel.vue?vue&type=script&lang=js"
export * from "./addNotePanel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__